import { z } from 'zod';

import { LOGIN_REDIRECT_QUERY_PARAM } from 'shared/services';

import { loginRedirectSchema } from '../shared';

/** Zod schema for `/auth/verify-email` URL search params. */
export const verifyEmailSearchSchema = z.object({
  /** Email address the verification code was sent to. */
  email: z.string().email(),
  /** Carried through from login, so verifying returns the user to where they were headed. */
  [LOGIN_REDIRECT_QUERY_PARAM]: loginRedirectSchema
});

/** Inferred type for the `/auth/verify-email` route search params. */
export type VerifyEmailSearch = z.infer<typeof verifyEmailSearchSchema>;
